module.exports = __webpack_public_path__ + "c4446c300a98ee30e1edf9bc8f65f8a1.svg";